import {
    CREATE_PERMISSION,
    DELETE_PERMISSION,
    NOTE_CONVERSATION_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import type { TPermissions } from 'src/interfaces/user';
import { DEVELOPER_LEVEL_ACCESS } from 'src/components/access';

type TNotePermissionUser = {
    permissions?: TPermissions;
    accessLevel?: string;
};

export const canCreateNoteConversation = (user?: TNotePermissionUser) =>
    isPermissionGranted({
        permissions: user?.permissions || {},
        permission: NOTE_CONVERSATION_AUTH,
        crud: CREATE_PERMISSION,
    });

export const canReadNoteConversation = (user?: TNotePermissionUser) =>
    isPermissionGranted({
        permissions: user?.permissions || {},
        permission: NOTE_CONVERSATION_AUTH,
        crud: READ_PERMISSION,
    });

export const canUpdateNoteConversation = (user?: TNotePermissionUser) =>
    isPermissionGranted({
        permissions: user?.permissions || {},
        permission: NOTE_CONVERSATION_AUTH,
        crud: UPDATE_PERMISSION,
    });

export const canDeleteNoteConversation = (user?: TNotePermissionUser) =>
    isPermissionGranted({
        permissions: user?.permissions || {},
        permission: NOTE_CONVERSATION_AUTH,
        crud: DELETE_PERMISSION,
    }) && user?.accessLevel === DEVELOPER_LEVEL_ACCESS;

export const NOTE_MESSAGE_KIND = 'note';

export const getConversationMessagesKindFilter = (
    user?: TNotePermissionUser
): Record<string, unknown> =>
    canReadNoteConversation(user) ? {} : { kind: { $ne: NOTE_MESSAGE_KIND } };

export const buildConversationMessageFilters = (
    user?: TNotePermissionUser,
    overrides: {
        page?: number;
        limit?: number;
        sort?: string;
    } = {}
) => ({
    page: 1,
    limit: 30,
    sort: '-createdAt',
    ...getConversationMessagesKindFilter(user),
    ...overrides,
});

export const isNoteMessage = (message: { type?: string; kind?: string }) =>
    message?.kind === 'note';

export const canReceiveConversationMessage = (
    message: { type?: string; kind?: string },
    user?: TNotePermissionUser
) => !isNoteMessage(message) || canReadNoteConversation(user);
